import React from 'react'
import config from 'config'
import { get } from 'lodash'

import {
  PaymentGPWPInit,
  PaymentGPWPResult
} from 'containers/pages'

const urlPrefix = `${config.publicPath}`

export default [
  {
    path: `${urlPrefix}/gp-wp-init/:authCode`,
    exact: true,
    component: props => (
      <PaymentGPWPInit
        {...props}
        params={get(props, 'match.params', {})}
      />
    ),
    routes: []
  },
  {
    path: `${urlPrefix}/gp-wp-result/:authCode`,
    exact: true,
    component: props => (
      <PaymentGPWPResult
        {...props}
        params={get(props, 'match.params', {})}
      />
    ),
    routes: []
  }
]


